/**
 * Frontend runtime config.
 * API base URL is overridable at build time via REACT_APP_API_URL
 * (CRA inlines REACT_APP_* env vars). Defaults to the local backend.
 * In production the frontend and API share an origin (Caddy routes /api/*
 * to the backend), so this is just the https origin.
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:8001';

// localStorage keys — namespaced to avoid collisions on shared origins.
export const TOKEN_KEY = 'aichurchflow.accessToken';
export const USER_KEY = 'aichurchflow.user';

// Window event the API client emits when auth is lost, so AuthProvider
// can clear React state without a circular import.
export const LOGOUT_EVENT = 'aichurchflow:logout';
